import projectData from './project-data';
import {TranslatorFunction} from '../../gui-config';


import popWav from '!arraybuffer-loader!./83a9787d4cb6f3b7632b4ddfebf74367.wav?';
import meowWav from '!arraybuffer-loader!./83c36d806dc92327b9e7049a565c6bff.wav?';
import backdrop from '!raw-loader!./cd21514d0531fdffb22204e0ec5ed84a.svg?';
import costume1 from '!arraybuffer-loader!./b0fca233ad201a0fac289e123191a2e4.png?';
import costume2 from '!arraybuffer-loader!./fb2750fd3fb0fb1074705cff5d4395d2.png?';
import costume3 from '!arraybuffer-loader!./d472ff5aa02e38c756f50ab38ecf226f.png?';
import costume4 from '!arraybuffer-loader!./ae5da50f2e4008eaef487e0fac6bcf2c.png?';
import costume5 from '!arraybuffer-loader!./15064d4fc87fc24d999f725c1e282ba3.png?';
import costume6 from '!arraybuffer-loader!./f6e635f6687bce6ebad389b33f6c3b1c.png?';
import costume7 from '!arraybuffer-loader!./3d221ac554c3e0b503e64d46a180af03.png?';
import costume8 from '!arraybuffer-loader!./3b6ebda9bd09661fb8eb252d9fea082b.png?';
import costume9 from '!arraybuffer-loader!./3953ab7be30595a545f387e8c463a4dd.png?';
import costume10 from '!arraybuffer-loader!./70f5af8af7348675c4f0f3e5c9286e08.png?';
import costume11 from '!arraybuffer-loader!./550241e806d550454e945fa53a3fd059.png?';


declare function require (path: 'fastestsmallesttextencoderdecoder'): {TextEncoder: typeof TextEncoder};

const defaultProject = (translator?: TranslatorFunction) => {
    let _TextEncoder: typeof TextEncoder;
    if (typeof TextEncoder === 'undefined') {
        _TextEncoder = require('fastestsmallesttextencoderdecoder').TextEncoder;
    } else {
        _TextEncoder = TextEncoder;
    }
    const encoder = new _TextEncoder();

    const projectJson = projectData(translator);
    return [{
        // TODO: This is weird - the ids are annotated by scratch-storage to be strigns, but
        //       this one is an int. May have implications on checking with `!` and in conditions,
        //       so leaving it as is for now.
        id: 0,
        assetType: 'Project',
        dataFormat: 'JSON',
        data: JSON.stringify(projectJson)
    }, {
        id: '83a9787d4cb6f3b7632b4ddfebf74367',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(popWav)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bff',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(meowWav)
    }, {
        id: 'cd21514d0531fdffb22204e0ec5ed84a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(backdrop)
    }, {
        id: 'b0fca233ad201a0fac289e123191a2e4',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume1)
    }, {
        id: 'fb2750fd3fb0fb1074705cff5d4395d2',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume2)
    }, {
        id: 'd472ff5aa02e38c756f50ab38ecf226f',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume3)
    }, {
        id: 'ae5da50f2e4008eaef487e0fac6bcf2c',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume4)
    }, {
        id: '15064d4fc87fc24d999f725c1e282ba3',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume5)
    }, {
        id: 'f6e635f6687bce6ebad389b33f6c3b1c',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume6)
    }, {
        id: '3d221ac554c3e0b503e64d46a180af03',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume7)
    }, {
        id: '3b6ebda9bd09661fb8eb252d9fea082b',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume8)
    }, {
        id: '3953ab7be30595a545f387e8c463a4dd',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume9)
    }, {
        id: '70f5af8af7348675c4f0f3e5c9286e08',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume10)
    }, {
        id: '550241e806d550454e945fa53a3fd059',
        assetType: 'ImageBitmap',
        dataFormat: 'PNG',
        data: new Uint8Array(costume11)
    }];
};

export default defaultProject;
